<template>
  <!-- Background overlay -->
  <div
    class="sidebar_overlay"
    @click.self="close"
    :class="[show ? '' : 'hidden']"
  />
  <!-- sidebar container -->
  <div
    class="w-64 bg-gray-900 fixed top-0 h-screen z-10 overflow-hidden sidebar_container text-white z-50"
    :class="[show ? 'show' : '']"
  >
    <div
      class="w-64 h-14 top-0 fixed flex items-center justify-end px-4 border-b border-gray-700 bg-gray-900"
    >
      <button-icon :color="'text-white'" @click="close">
        <i class="far fa-times-circle fa-2x"></i
      ></button-icon>
    </div>
    <div class="overflow-y-auto pt-16">
      <slot />
    </div>
  </div>
</template>

<script>
import { watch } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "sidebar-base",
  props: {
    show: Boolean
  },
  setup(props, { emit }) {
    const route = useRoute();
    const close = () => {
      emit("closeSidebar");
    };

    watch(
      () => route.fullPath,
      () => {
        if (props.show) {
          close();
        }
      }
    );

    return {
      close
    };
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  &_overlay {
    background-color: rgba(27, 36, 51, 0.75);
    width: 100%;
    height: 100%;
    position: fixed;
    transition: all 0.3s ease-in-out;
    opacity: 0.75;
    z-index: 20;
  }

  &_container {
    left: -256px;
    transition: all 0.3s ease-in-out;

    &.show {
      transform: translateX(256px);
    }
  }
}
</style>
